import {FullLoadConfiguration} from '../../../../fields/fullLoad/types'
import {QuantityConfiguration, QuantityForm} from '../../../../fields/quantity/types'
import {CreateFormInput} from '../types'

export const buildQuantityForm = ({
  order,
  configuration
}: CreateFormInput<QuantityConfiguration & FullLoadConfiguration>): QuantityForm => {
  const lineItem = order.lineItems[0]
  const quantityUom = configuration.quantity.uom ?? lineItem.quantityUom

  // Detect fullLoads: if lineItem has distinct minQuantity/maxQuantity, match to a fullLoad option
  if (
    configuration.fullLoad.isEnabled &&
    lineItem.minQuantity !== undefined &&
    lineItem.maxQuantity !== undefined &&
    lineItem.maxQuantity - lineItem.minQuantity > 0
  ) {
    const matchingOption = configuration.fullLoad.options.find(
      (opt) => opt.minQuantity === lineItem.minQuantity && opt.maxQuantity === lineItem.maxQuantity
    )
    if (matchingOption) {
      return {
        quantity: {
          type: 'fullLoads',
          fullLoads: matchingOption.numberOfLoads,
          minQuantity: matchingOption.minQuantity,
          maxQuantity: matchingOption.maxQuantity,
          quantityUom
        }
      }
    }
  }

  return {
    quantity: {
      type: 'volume',
      volume: lineItem.quantity,
      quantityUom
    }
  }
}
